module.exports = __webpack_public_path__ + "img/gongdaojun.8ec620eb.jpg";